export default __webpack_public_path__ + "static/media/main_level_test03_cn.d5d0f413.png";